import { render, staticRenderFns } from "./BuildPopup.vue?vue&type=template&id=82cad15e&scoped=true&"
import script from "./BuildPopup.vue?vue&type=script&lang=js&"
export * from "./BuildPopup.vue?vue&type=script&lang=js&"
import style0 from "./BuildPopup.vue?vue&type=style&index=0&id=82cad15e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82cad15e",
  null
  
)

export default component.exports